module.exports = __webpack_public_path__ + "static/media/airbnb-logo.683ad3b5.png";